import { ref } from 'vue';
import $ from 'jquery';

const alerts = ref([]);
/**
 * @description 警示跳窗
 * @param {String} msg 回傳訊息
 * @param {String} type 樣式 alert、confirm
 * @param {Function} callback
 * @param {String} dataName 抓取特定跳窗時
 */
function showAlert(msg, type, callback, dataName) {
  // 有時有多個警示視窗
  alerts.value.push({ msg, type, callback, dataName });

  const $body = $('body');
  $body.css({ overflow: 'hidden' });
}

function closeAlert(index) {
  alerts.value.splice(index, 1);
  const $body = $('body');
  $body.css({ overflow: '', 'padding-right': '' });
}

// 這是為不改變太多的寫法給前、後端用的
const allAlertFn = () => {
  const o = {};
  o.alert = (msg, callback, name) => {
    showAlert(msg, 'alert', callback, name);
  };

  o.confirm = (msg, callback, name) => {
    showAlert(msg, 'confirm', callback, name);
  };

  o.special = (msg, callback, name) => {
    showAlert(msg, 'special', callback, name);
  };
  return o;
};
const alertDialog = allAlertFn();

function useAlert() {
  return { alerts, alertDialog, showAlert, closeAlert };
}

export default useAlert;
